import React from 'react';
import translate from '@/utils/translate';
import {CampaignApprovalStep} from '@/types/campaign';
import BriefSubSection from '@/views/campaigns/brief/components/campaign-brief/components/brief-sub-section';
import {SectionProps} from '@/views/campaigns/brief/components/campaign-brief/section/SectionProps';
import {
  APPROVAL_STEPS,
  APPROVAL_STEP_LABELS,
} from '@/views/campaigns/constants/approvalSteps';
import useAddCampaignApprovalStep from '@/hooks/mutations/use-add-campaign-approval-step';
import useRemoveCampaignApprovalStep from '@/hooks/mutations/use-remove-campaign-approval-step';
import styles from './RequiredApprovalSteps.module.scss';
import StepCheckbox from './StepCheckbox';

function RequiredApprovalSteps({campaign, editable}: SectionProps) {
  const campaignApprovalSteps = campaign.campaignApprovalSteps || [];
  const checkedSteps = new Set(
    campaignApprovalSteps.map((cas: CampaignApprovalStep) => cas.step)
  );

  const {mutate: addStep} = useAddCampaignApprovalStep({
    campaignId: campaign.id,
  });
  const {mutate: removeStep} = useRemoveCampaignApprovalStep({
    campaignId: campaign.id,
  });

  const handleAdd = (step: string) => {
    addStep({campaignId: campaign.id, step});
  };

  const handleRemove = (step: string) => {
    const record = campaignApprovalSteps.find(
      (cas: CampaignApprovalStep) => cas.step === step
    );
    if (record) {
      removeStep({campaignId: campaign.id, campaignApprovalStepId: record.id});
    }
  };

  return (
    <div className={styles.container}>
      <BriefSubSection
        disabled={!editable}
        title={translate('Required Approval Steps')}
      >
        <div className={styles.checkboxesContainer}>
          {APPROVAL_STEPS.map((step) => (
            <StepCheckbox
              key={step}
              step={step}
              label={APPROVAL_STEP_LABELS[step]}
              checked={checkedSteps.has(step)}
              disabled={!editable}
              onAdd={handleAdd}
              onRemove={handleRemove}
            />
          ))}
        </div>
      </BriefSubSection>
    </div>
  );
}

export default RequiredApprovalSteps;
